<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <div
    v-if="element"
    ref="refElement"
    v-draggable="user.is_admin && !element.is_editing"
    v-notices-dragging="methodDragging"
    :data-unique="element.unique"
    :style="{
      order: element.order || dataElementI || 0,
    }"
    :class="{
      'border-t-4 -mt-1 border-blue-400 border-dashed ': dataNoticedDraggingIsAbove && dataNoticedDraggingIsAboveUpperHalf,
      'border-b-4 -mb-1 border-blue-400 border-dashed ': dataNoticedDraggingIsAbove && !dataNoticedDraggingIsAboveUpperHalf,
    }"
    @mouseenter="(isClient && user.is_admin) ? element.is_hovering = true : []"
    @mouseleave="(isClient) ? element.is_hovering = false : []"
    >

    <!-- ================================ ORDER DEBUG  -->
    <!-- <div class="relative w-0 h-0">
      <div
        class="absolute p-2 rounded-lg text-xs shadow shadow-black"
        :class="{
          'bg-blue-300': dataNoticedDraggingIsAbove && dataNoticedDraggingIsAboveUpperHalf,
          'bg-red-300': dataNoticedDraggingIsAbove && !dataNoticedDraggingIsAboveUpperHalf,
          'bg-white': !dataNoticedDraggingIsAbove,
        }"
        >
        {{ element.order }}
      </div>
    </div> -->

    <div
      :class="[
        'blog-item blog-item-'+element.type.toLowerCase(),
        (element.type.toLocaleLowerCase() === 'heading')
          ? 'blog-item-heading-'+(element.meta?.headline_type ?? 'h1')
          : '',
      ]"
      >
      <!-- The component to be shown from element.type -->
      <component
        :is="methodIsComponent(element?.type)"
        ref="refComponent"
        v-model:blog="modelBlog"
        v-model="element"
        :class="{
          '!outline-blue-500/20 !outline-dashed': element.is_hovering
        }"
        :readonly="!element.is_editing"
        :data-styling="!!element?.meta?.custom_css ? element.id : false"
        @remove="$emit('remove')"
        />

      <!-- Custom CSS for the component -->
      <component
        v-if="element?.meta?.custom_css"
        :is="'style'"
        v-html="computedStyle"
        />

      <BlogElementAdminHoverable
        v-if="element && !dataNoticedIsBeingDragged"
        v-model="element"
        v-model:blog="modelBlog"
        @remove="$emit('remove')"
        @addbelow="$emit('addbelow')"
        @addabove="$emit('addabove')"
        @moveup="$emit('moveup')"
        @movedown="$emit('movedown')"
        />
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['remove','addbelow','addabove','moveup','movedown'])
defineProps<{
  dataElementI?: number
}>()

const isClient = computed(() => typeof window !== 'undefined');

const dataNoticedIsBeingDragged = ref<boolean>(false)
const dataNoticedDragging = ref<boolean>(false)
const dataNoticedDraggingIsAbove = ref<boolean>(false)
const dataNoticedDraggingIsAboveUpperHalf = ref<boolean>(false)

const element = defineModel<BlogElement>()
const modelBlog = defineModel<Blog>('blog')

const refElement = ref<HTMLElement | null>(null)

const methodDragging = (event: any) => {
  if(event.isBeingDragged && event.isDragging){
    return dataNoticedIsBeingDragged.value = event.isBeingDragged
  }

  if(!event.isDragging) {
    dataNoticedIsBeingDragged.value = false
  }

  // if(event.element == refElement.value && event.isDragging) return;
  if(event.isDroppable && !event.isDragging){
    if (!modelBlog.value) {
      console.warn('Blog model is not defined, cannot insert element');
      return;
    }

    if (!element.value) {
      console.warn('Element is not defined, cannot insert element');
      return;
    }

    methodInsertElement(modelBlog.value, event.element.dataset.unique, element.value.unique, !event.isAboveUpperHalf);
  }

  dataNoticedDragging.value = !!event.isDragging && event.isDroppable
  dataNoticedDraggingIsAbove.value = !!event.isDragging && !!event.isAbove && event.isDroppable
  dataNoticedDraggingIsAboveUpperHalf.value = !!event.isDragging && !!event.isAboveUpperHalf && event.isDroppable

}

const methodIsComponent = (type: undefined|null|string) => {
  type = type?.toLowerCase()

  if(type === 'title'){
    type = 'heading'
  }

  return 'blog-content-'+(type ?? 'paragraph')
}

const computedStyle = computed(() =>{
  return element.value?.meta.custom_css
    ?.replace('.selector','[data-styling="'+element.value.id+'"]')
    .replace(/\n/g,'')
    .replace(/\t/g,'')
    .replace(/ {2}/g,' ')
})

</script>
